import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { Transport } from "interfaces/transport";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_PANEL_TRANSPORTS_" }
);

export interface ListPanelTransportsState extends IState {
  data: Transport[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: Transport[];
}

const INITIAL_STATE: ListPanelTransportsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListPanelTransportsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListPanelTransportsState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListPanelTransportsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listPanelTransports = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListPanelTransportsTypes = Types;
export const ListPanelTransportsActions = Creators;
